import React from 'react';
import { twMerge } from 'tailwind-merge';

const Wrapper = ({
  children,
  className = '',
  type = 'default' || 'prominent',
  texture = '',
  color = '',
}) => {
  return type === 'default' ? (
    <div className={twMerge('w-full flex gap-3 items-start leading-none', className)}>
      {children}
    </div>
  ) : (
    <div className={twMerge('relative flex flex-col', texture ? texture : 'bg-texture-focus')}>
      <div className="absolute z-0 inset-3 lg:inset-12 bg-white" />
      <div
        className={twMerge('absolute z-10 inset-3 lg:inset-12', color ? color : 'bg-new-teal-9')}
      />
      <div className={twMerge('relative z-20 h-full w-full p-3 lg:p-12', className)}>
        {children}
      </div>
    </div>
  );
};

export default Wrapper;
